import ClinicConnectorEdit from './ClinicConnectorEdit.vue'
import ClinicConnectorMonitor from './ClinicConnectorMonitor.vue'

export default {
  name: 'ClinicConnectorsTab',
  props: ['clinic_id', 'clinic_uuid'],
  components: {
    ClinicConnectorEdit,
    ClinicConnectorMonitor,
  },
  data: () => ({
    loading: false,
    view: 'catalog',
    partners: [],
    tablePartners: null,
    isEdit: false,
    selectedPartner: null,
  }),
  mounted() {
    this.fetchData()
  },
  methods: {
    fetchData: async function() {
      this.loading = true
      NProgress.start()
      try {
        let response = await this.$connectorService.listPartners(this.clinic_id)
        let partners = response.result ? response.result : []
        this.partners = partners.map(p => ({
          ...p,
          analysesText: (p.analyses || []).join(', ')
        }))
        this.tablePartners = {
          'items': this.partners,
          'columns': [
            {name: this.$i18n.t('connector.partner'), type: 'custom', key: 'partner', width: '40%'},
            {name: this.$i18n.t('connector.analyses'), type: 'string', value: 'analysesText', width: '30%'},
            {name: this.$i18n.t('integration.statusCol'), type: 'custom', key: 'status', width: '30%'},
          ]
        }
      } catch (err) {
        console.log(err)
        this.$message.popup(this, 'request_error', 'operationFail', 'error')
      }
      NProgress.done(true)
      this.loading = false
    },
    statusClass(item) {
      if (!item.integration) return 'unconfigured'
      return item.integration.enabled ? 'connected' : 'disabled'
    },
    statusLabel(item) {
      if (!item.integration) return this.$i18n.t('connector.statusUnconfigured')
      return item.integration.enabled
        ? this.$i18n.t('connector.statusConnected')
        : this.$i18n.t('connector.statusDisabled')
    },
    toDetails(values) {
      if (!values || !values.item) {
        return
      }
      this.selectedPartner = values.item
      this.isEdit = true
    },
    cancelEdit() {
      this.selectedPartner = null
      this.isEdit = false
    },
    onSaved() {
      this.selectedPartner = null
      this.isEdit = false
      this.fetchData()
    },
    setView(view) {
      this.view = view
      this.isEdit = false
      this.selectedPartner = null
    },
  }
}
